import '../sass/home-header.scss';

import animationData from '../../../../assets/lottie/logo.json';

(() => {
    const swiperScript = document.querySelector('#boomspace-theme-swiper-js');
    const lottieScript = document.querySelector('#boomspace-theme-lottie-js');
    const $blocks = document.querySelectorAll('.home-header');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const backgroundColours = ['background-color-yellow', 'background-color-sage', 'background-color-mauve', 'background-color-pink'];

        const $carouselOverlay = $block.querySelector('.home-header__carousel-overlay');
        const $slider = $block.querySelector('.home-header__carousel-slider');

        let animationComplete = false;

        let slider, overlay = null;

        const initSlider = () => {
            if (!$slider) return;

            slider = new Swiper($slider, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 300,
                allowTouchMove: false,
            });

            slider.autoplay.stop();

            slider.on('slideChange', () => {
                const currentColour = $block.dataset.currentColour ?? backgroundColours[backgroundColours.length - 1];
                const nextColour = backgroundColours[backgroundColours.indexOf(currentColour) + 1 > backgroundColours.length - 1 ? 0 : backgroundColours.indexOf(currentColour) + 1];
                
                $block.classList.remove(currentColour);
                $block.classList.add(nextColour);
                $block.dataset.currentColour = nextColour;
            });

            slider.on('autoplayStart', () => {
                $carouselOverlay.classList.add('home-header__carousel-overlay--hide');
                $slider.classList.add('home-header__carousel-slider--show');
            });

            if (animationComplete) {
                slider.autoplay.start();
            }
        }

        const initAnimation = () => {
            overlay = lottie.loadAnimation({
                container: $carouselOverlay,
                renderer: 'canvas',
                loop: false,
                autoplay: true,
                animationData: animationData,
                initialSegment: [0, 220],
                rendererSettings: {
                    preserveAspectRatio: 'none'
                }
            });

            overlay.addEventListener('complete', () => {
                animationComplete = true;

                if (!slider) return;

                slider.autoplay.start();
            });
        };

        if (lottie) {
            initAnimation();
        } else {
            lottieScript.addEventListener('load', () => {
                initAnimation();
            });
        }

        if (typeof Swiper !== 'undefined') { 
            initSlider();
        } else {
            swiperScript.addEventListener('load', () => {
                initSlider();
            });
        }
    });
})();
